export const animateRefundAmount = (
  element: HTMLElement,
  refundAmount: number
): void => {
  if (!element) return;

  const startValue = 1;
  const end = refundAmount;
  const duration = 2000;
  const startTime = performance.now();

  const animate = (time: number) => {
    const progress = Math.min((time - startTime) / duration, 1);
    const value = (startValue + progress * (end - startValue)).toFixed(2);

    element.textContent = `₹${value} Cr`;
    element.style.transform = `translateY(-100%)`;

    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      element.style.transform = `translateY(100%)`;
    }
  };

  requestAnimationFrame(animate);
};
